import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/bank-connections")({
  staticData: {
    breadcrumb: "Bank Connections",
  },
  component: () => <Outlet />,
});
